<script setup lang="ts">

import { computed } from "vue";
import type { WizardNavigation } from "../Types/WizardNavigation";

interface INavigationProps
{
    returnTo: string
}

const model = defineModel<WizardNavigation>( { required: true } );
const props = defineProps<INavigationProps>();
const emit = defineEmits( [ 'on-complete' ] );

const isFirstPage = computed( () => model.value.index == 0 );
const isLastPage = computed( () => model.value.index == model.value.finalIndex );
const isConfirmationPage = computed( () => model.value.isComplete );

</script>

<template>

    <div class="grid grid-cols-2 gap-2 w-full p-4 pb-8"
         :class="{ 
             '!grid-cols-1': isFirstPage || model.isComplete,
             'pointer-events-none opacity-40': model.isBusy || model.isValid == false
         }">
        <Button v-if="model.index > 0 && isConfirmationPage == false"
                color="secondary"
                variant="outlined"
                size="large"
                @click="model.back()">
            Back
        </Button>
        <Button v-if="isConfirmationPage == false"
                color="secondary"
                variant="flat"
                size="large"
                @click="() => model.next()">
            {{ isLastPage ? 'Book' : 'Next' }}
            <Icon :name="isLastPage ? 'check' : 'arrow-right'"
                  class="ml-1"/>
        </Button>
        <Button v-else
                color="secondary"
                variant="flat"
                size="large"
                :to="returnTo">
            <Icon name="home"
                  class="ml-1"/>
            Return
        </Button>
    </div>

</template>